import toasted from '@/utils/toasted';
import _ from 'lodash';
import moment from 'moment';
import EditeurEntite from '@/plugins/mixins/EditeurEntite';

export default {
  mixins: [EditeurEntite],
  data() {
    return {
      controlAction: {
        refuserDemande: this.__refuserDemande,
        validerDemande: this.validerDemande,
        demanderComplement: this.__demanderComplement,
        repondreComplement: this.__repondreComplement,
      },
      control: {
        complementsPossible: true,
        dialogValider: false,
        validerDemande: false,
        dialogRefuser: false,
        dialogMotifRefus: false,
        dialogDemander: false,
        dialogRepondre: false,
        demanderComplement: false,
        repondreComplement: false,
        repondreComplementId: null,
        commentaireComplement: null,
        motifRefus: null,
        refuserDemande: false,
        droitTraitement: false,
        isDemandeur: false,
        isTerminer: false,
      },
      diff: {
        ajoutes: [],
        anciennes: {},
        supprimes: {},
      },
      idDemande: null,
      demandeur: null,
      typeDemande: null,
      codeTypeDemande: null,
      dateCreation: null,
      commentaire: null,
      complements: [],
    };
  },

  provide() {
    return {
      controlAction: this.controlAction,
    };
  },

  methods: {
    /**
    validerDemande() {
      //XXX methode à implémenter dans le composant utilisant le mixins
    },

    */

    initEditeurDemande(data) {
      //chargement du diff
      this.diff = data.diff;
      this.idDemande = data.id;
      this.typeDemande = data.demandeType.libelle;
      this.codeTypeDemande = data.demandeType.code;
      this.demandeur = data.demandeurCreation;
      this.commentaire = data.commentaire;
      this.motifRefus = data.motifRefus;
      this.complements = data.complements;
      this.control.droitTraitement = data.droitTraitement;
      this.control.isDemandeur = data.isDemandeur;
      this.control.terminer = [1, 2].includes(data.status.id);
      this.control.readonly =
        this.codeTypeDemande === 'suppression' || !this.control.droitTraitement;

      this.dateCreation = moment(data.dateCreation).format(
        'DD/MM/YYYY [à] HH:mm',
      );
    },

    creationFiltreSupprimes(path, byIndex = false) {
      return (val, index) => {
        const id = byIndex ? index : val.id;
        const search = `${path}[${id}]`;
        const found = this.diff.supprimes.indexOf(search) < 0;
        return found;
      };
    },

    annulerSuppression(path) {
      const supprimes = this.diff.supprimes;
      const index = supprimes.indexOf(path);
      if (index >= 0) supprimes.splice(index, 1);
    },

    __demanderComplement() {
      const id = this.idDemande;
      this.control.demanderComplement = true;
      this.$api(`workflow/demande/${id}/commentaire`)
        .post({
          commentaire: this.control.commentaireComplement,
          idUtilisateur: this.control.nomUtilisateurAGIL,
        })
        .then(() => {
          toasted.info('demande.status.commentaire');
          this.__annuler(false);
          this.$router.push({ name: 'workflow/demande' });
        })
        .finally(() => (this.control.demanderComplement = false));
    },

    __repondreComplement() {
      const id = this.control.repondreComplementId;
      this.control.repondreComplement = true;
      this.$api(`workflow/demande/commentaire/${id}/reponse`)
        .post({ commentaire: this.control.reponseComplement })
        .then(() => {
          toasted.info('demande.status.commentaire');
          this.__annuler(false);
          this.$router.push({ name: 'workflow/mesdemandes' });
        })
        .finally(() => (this.control.demanderComplement = false));
    },

    __refuserDemande() {
      const id = this.idDemande;
      this.control.refuserDemande = true;
      this.$api(`workflow/demande/${id}/refuser`)
        .post(this.control.motifRefus)
        .then(() => {
          toasted.info('demande.status.refuse');
          this.__annuler(false);
          this.$router.push({ name: 'workflow/demande' });
        })
        .finally(() => (this.control.refuserDemande = false));
    },
  },

  computed: {
    analyseDiff() {
      const color = {};
      const supprime = {};
      const hint = {};
      if (this.diff) {
        _.forOwn(this.diff.anciennes, (value, key) => {
          color[key] = 'accent';
          var val = value;
          if (value && typeof value === 'object') val = value.libelle;

          hint[key] = `Ancienne valeur : ${val}`;
        });

        _.forEach(this.diff.supprimes, value => {
          color[value] = 'error';
          color[value.substr(0, value.lastIndexOf('['))] = 'accent';
          supprime[value] = true;
        });

        _.forEach(this.diff.ajoutes, value => {
          color[value] = 'secondary';
          color[value.substr(0, value.lastIndexOf('['))] = 'accent';
        });
      }

      return {
        color,
        supprime,
        hint,
      };
    },
  },
};
